import { LOGO_ALT, LOGO_DARK_SRC, LOGO_SRC } from '../../config/branding';

export default function Logo({ variant = 'light', className = 'h-10 w-auto object-contain', ...props }) {
  const src = variant === 'dark' ? LOGO_DARK_SRC : LOGO_SRC;
  return <img src={src} alt={LOGO_ALT} className={className} {...props} />;
}
